export const environment = {
  production: true,
  API_URL: 'https://api-dev-1of1events.onrender.com',
  API_KEY: 'HCvsGBbKzglUZ4rIKsikfPSMCjZHfcbW',
  BANK: {
    NAME: 'BMCE BANK (Bank of Africa)',
    OWNER: 'Association de Gérontologie Espoir (AGE)',
    RIB: '011 780 00000421000 01398 62',
  },
};
